import { render, staticRenderFns } from "./testModal.vue?vue&type=template&id=0645789a&scoped=true"
import script from "./testModal.vue?vue&type=script&lang=ts"
export * from "./testModal.vue?vue&type=script&lang=ts"
import style0 from "./testModal.vue?vue&type=style&index=0&id=0645789a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0645789a",
  null
  
)

export default component.exports